"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageMap = void 0;
class MessageMap {
    constructor(timer = 30) {
        this.map = new Map();
        this.timer = timer;
    }
    /**
     * Message callback to queue operations.
     */
    push(id, resolve, reject, allowTimeout = false) {
        const messageData = {
            id,
            success: true,
            resolve,
            reject
        };
        if (!allowTimeout) {
            messageData.timer = setTimeout(() => {
                this.put(id);
                reject === null || reject === void 0 ? void 0 : reject({
                    id,
                    success: false,
                    msg: 'Message Event Timeout'
                });
            }, this.timer * 1000);
        }
        this.map.set(id, messageData);
    }
    /**
     * The message calls back the queueing operation and
     * triggers the event related to the completion of the operation.
     */
    pop(id, params) {
        var _a;
        const messageData = this.put(id);
        (_a = messageData === null || messageData === void 0 ? void 0 : messageData.resolve) === null || _a === void 0 ? void 0 : _a.call(messageData, params);
    }
    /**
     * Clear message memory.
     */
    clear() {
        this.map.forEach(p => p.timer && clearTimeout(p.timer));
        this.map = new Map();
    }
    /**
     * Take out the information corresponding to the specified ID.
     */
    put(id) {
        const messageData = this.map.get(id);
        if (!messageData)
            return;
        this.map.delete(id);
        messageData.timer && clearTimeout(messageData.timer);
        return messageData;
    }
}
exports.messageMap = new MessageMap();
